import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class PaymentPrepListItem extends SearchModelBase {
    paymentDate: string | null = null;
    fromPaymentDate: string | null = null;
    toPaymentDate: string | null = null;
    vendors: string = '';
    totalAmt: number|null = null;
    fromTotalAmt: number|null = null;
    toTotalAmt: number|null = null;
    isPaid: boolean = false;
    printDate: string | null = null;
    fromPrintDate: string | null = null;
    toPrintDate: string | null = null;
    printBy: string = '';
    id: number = 0;
    status: string = '';
    // u1ID: string = '';
    // u1Date: string | null = null;
    // fromU1Date: string | null = null;
    // toU1Date: string | null = null;
    // u2Date: string | null = null;
    // fromU2Date: string | null = null;
    // toU2Date: string | null = null;
    // u2ID: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Date', width: 75, dataIndex: 'paymentDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, defaultColumnFocus: true }),
        XCol.Create({ col: 2, text: 'Vendor', width: 250, dataIndex: 'vendors'}),
        XCol.Create({ col: 3, text: 'Amount', width: 100, dataIndex: 'totalAmt', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 4, text: 'Paid', width: 60, dataIndex: 'isPaid', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center , noNullOrEmptySearch: true}),
        XCol.Create({ col: 5, text: 'Print Date', width: 75, dataIndex: 'printDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 6, text: 'Print By', width: 100, dataIndex: 'printBy'}),
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection; 
    };
	
    public static OrderBy = { orderBy: PaymentPrepListItem.prototype.paymentDate, orderByAscending: false };

    public static formatData(data: PaymentPrepListItem[]) {
        return data.map((d: PaymentPrepListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        paymentDate: {from: 'fromPaymentDate', to: 'toPaymentDate'},
        totalAmt: {from: 'fromTotalAmt', to: 'toTotalAmt'},
        printDate: {from: 'fromPrintDate', to: 'toPrintDate'},
        // u1Date: {from: 'fromU1Date', to: 'toU1Date'},
        // u2Date: {from: 'fromU2Date', to: 'toU2Date'},
    }
}
